// removed by extract-text-webpack-plugin
module.exports = {"titleView":"titleView___7RH-p","mainTitle":"mainTitle___3Pqyt","subTitle":"subTitle___NDVh-","bottomView":"bottomView___1CYJu"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Shop/Home/ShopHome/components/Tabs/Components/RenderTab/index.modules.less
// module id = 729
// module chunks = 431